import { Tagline, Version, Wrapper } from './Logo.style';

export type LogoProps = {
  tagline?: string;
  version: string;
  onClick?: () => void;
};

export function Logo(props: LogoProps) {
  const { tagline, version } = props;

  function onVersionClick() {
    alert(version);
  }

  return (
    <Wrapper className='Logo-wrapper' data-testid='Logo-wrapper' onClick={props.onClick}>
      <img src='/logo.svg' alt='Logo' />
      <Tagline>{tagline}</Tagline>
      <Version onClick={onVersionClick}>{version}</Version>
    </Wrapper>
  );
}

export default Logo;
